export default "__VITE_ASSET__63c4f639__"